module.exports = __webpack_public_path__ + "img/wagon_driving.5aad29ba.svg";